import React from 'react';
import './Footer.scss';
import { useTranslation } from 'react-i18next';

const Footer = (props) => {
  const { t } = useTranslation();

  return (
    <div id="contacto" className='contenedor_footer'>
      <div className='contenedor_footer_social'>
        <a href="https://www.facebook.com/Velasur-by-Grupo-Velas-100278439225721/" target={'_blank'}>
          <img src="/assets/Logos/svg-icon-facebook.svg" alt="Facebook" />
        </a>
        <a href="https://instagram.com/velasur_qro?utm_medium=copy_link" target={'_blank'}>
          <img src="/assets/Logos/svg-icon-instagram.svg" alt="Instagram" />
        </a>
      </div>
      <div className='contenedor_footer_logo'>
        <a href="https://grupovelas.com.mx/" target={'_blank'}>
          <img src="/assets/Logos/svg-logo-grupo-velas.svg" alt="Grupo Velas" />
        </a>
      </div>
      <div className='contenedor_footer_tel'>
        <a href="tel:+524461340798" target={'_blank'}>
          {t('footer.phone')}
        </a>
      </div>
      <div className='contenedor_footer_info'>
        <p>
          © 2025 Grupo Velas ® {t('footer.rights')} |{' '}
          <a onClick={() => { props.setModalAviso(true) }}>
            {t('footer.privacyPolicy')}
          </a>
        </p>
        <p>{t('footer.disclaimer')}</p>
        
        <p>Las imágenes, renders, ilustraciones, planos y demás materiales gráficos son representaciones artísticas con fines exclusivamente ilustrativos. El proyecto, sus acabados, especificaciones, dimensiones, equipamiento, áreas, elementos arquitectónicos y precios podrán presentar modificaciones derivadas del proceso de diseño, ingeniería, construcción o disposiciones técnicas, sin previo aviso. En consecuencia, las imágenes no constituyen una representación exacta ni un compromiso respecto del producto final. La presente leyenda aplica para todos los materiales de comunicación, promoción y publicidad emitidos desde el inicio del proyecto.</p>
      </div>
    </div>
  );
};

export default Footer;
